import { IOptions } from '../options';

export type InsightDataDto = {
  hits: number;
  total: number;
  last7Days: number;
  jobSkills?: number[];
  edu: (IOptions & { count: number })[];
  exp: (IOptions & { count: number })[];
  compatibility: (IOptions & { count: number })[];
  degree_ids?: number[];
  required_exp?: {
    min: number;
    max: number;
  };
};

export function calcCount(value: number): string {
  if (value <= 4) {
    return String(value);
  }
  if (value <= 9) {
    return `${Math.floor(value / 5) * 5}+`;
  }
  if (value <= 49) {
    return `${Math.floor(value / 10) * 10}+`;
  }
  return `${Math.floor(value / 50) * 50}+`;
}

export function calcPercent(param: { total: number; qty: number }): string {
  const { total, qty } = param;
  if (total <= 0) return '0 %';
  return `${Math.round((qty / total) * 100)} %`;
}

export const mockInsightData: InsightDataDto = {
  hits: 1000,
  total: 452,
  last7Days: 151,
  jobSkills: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  edu: [
    {
      id: 3,
      name_mn: 'Доктор',
      name_en: 'Ph.D',
      count: 151,
    },
    {
      id: 2,
      name_mn: 'Магистр',
      name_en: 'Master',
      count: 110,
    },
    {
      id: 1,
      name_mn: 'Бакалавр',
      name_en: 'Bachelor',
      count: 72,
    },
    {
      id: 8,
      name_mn: 'Мэргэшсэн',
      name_en: 'Certified diploma',
      count: 49,
    },
    {
      id: 4,
      name_mn: 'Тусгай дунд',
      name_en: 'Associate degree',
      count: 37,
    },
    {
      id: 5,
      name_mn: 'Бүрэн дунд',
      name_en: 'High School',
      count: 33,
    },
    {
      id: 6,
      name_mn: 'Бүрэн бус дунд',
      name_en: 'Less than High School',
      count: 10,
    },
    {
      id: 7,
      name_mn: 'Бага',
      name_en: 'Primary School',
      count: 1,
    },
  ],
  exp: [
    {
      id: 3,
      name_mn: '0-2 жил',
      name_en: '0-2 years',
      count: 100,
    },
    {
      id: 2,
      name_mn: '2-5 жил',
      name_en: '2-5 years',
      count: 100,
    },
    {
      id: 1,
      name_mn: '5+ жил',
      name_en: '5+ years',
      count: 100,
    },
  ],
  compatibility: [
    {
      id: 285,
      name_mn: 'Англи хэл',
      name_en: 'English',
      count: 363,
    },
    {
      id: 666,
      name_mn: 'Microsoft Word',
      name_en: 'Microsoft Word',
      count: 315,
    },
    {
      id: 667,
      name_mn: 'Microsoft Excel',
      name_en: 'Microsoft Excel',
      count: 309,
    },
    {
      id: 1,
      name_mn: 'Багаар ажиллах',
      name_en: 'Teamwork',
      count: 279,
    },
  ],
  degree_ids: [2, 3],
  required_exp: {
    min: 0,
    max: 3,
  },
};

export const zangiaPlusPopupData = {
  title: 'Zangia Plus-тай танилц',
  description: 'Ажил горилохдоо давуу тал өгөх нэмэлт боломжууд',
  items: [
    {
      title: 'Ажил горилогчдын 7 төрлийн мэдээлэл харах эрх',
      value: 'Хязгааргүй',
      isRequired: true,
    },
    {
      title: 'CV болон ажлын зарын зохицол',
      value: 'Хязгааргүй',
      isRequired: true,
    },
    { title: 'Career зөвлөмж харах эрх', value: '24', isRequired: true },
    { title: 'Профайл зураг сайжруулах эрх', value: '60', isRequired: true },
    { title: 'CV зөвлөмж авах эрх', value: '60', isRequired: true },
    {
      title: 'CV бааз хайлтад дээгүүр жагсах',
      value: 'Хязгааргүй',
      isRequired: false,
    },
    {
      title: 'Шинэ ажлын байранд эхэнд санал болгох',
      value: 'Хязгааргүй',
      isRequired: false,
    },
  ],
};
